export default __webpack_public_path__ + "static/media/cozy2.bdda16b8.jpeg";